import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Box, Button, Container, Divider, Typography,
  Table, TableContainer, TableHead, TableRow, TableCell, TableBody,
  Paper, TextField, Dialog, DialogTitle, DialogContent, DialogActions, useMediaQuery
} from '@mui/material';
import { db } from '../../firebase';
import { doc, getDoc, query, collection, where, getDocs } from 'firebase/firestore';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import Alerts from '../../components/Alerts';

export default function RequestBill({ unitCode, cartId: propCartId,
  serviceArea: propServiceArea }) {
  //const { state, location } = useLocation();
  const navigate = useNavigate();
  const [openWhatsAppDialog, setOpenWhatsAppDialog] = useState(false);
  const [whatsAppNumber, setWhatsAppNumber] = useState('');
  const [cart, setCart] = useState([]);
  const [baseSubtotal, setBaseSubtotal] = useState(0);
  const [totalCGST, setTotalCGST] = useState(0);
  const [totalSGST, setTotalSGST] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const [companyName, setCompanyName] = useState(null);
  const [companyAddress, setCompanyAddress] = useState(null);
  const [companyPhone, setCompanyPhone] = useState(null);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const [gstPlans, setGstPlans] = useState([]);
  const [orderId, setOrderId] = useState(null);
const location = useLocation();
const state = location.state || {};
const searchParams = new URLSearchParams(location.search || "");
  const tableId = state?.tableId || new URLSearchParams(location.search).get('id') || null;
  //const orderId = state?.orderId || localStorage.getItem('currentOrderId') || null;
  const companyCode = state?.companyCode || new URLSearchParams(location.search).get('code') || null;
  const stateUnitCode = state?.unitCode || new URLSearchParams(location.search).get('unit') || null;
  const effectiveUnitCode = unitCode || stateUnitCode;
 
  const cartId =
  state.cartId ||
  new URLSearchParams(location.search).get('cartId')  ||
  propCartId;

const serviceArea =
  state.serviceArea ||
  new URLSearchParams(location.search).get('serviceArea') ||
  propServiceArea;
  const isMobile = useMediaQuery('(max-width:600px)');

  useEffect(() => {
    const fetchCompanyDetails = async () => {
      if (!companyCode) {
        setCompanyName('Unknown Company');
        setCompanyAddress('N/A');
        setCompanyPhone('N/A');
        console.log('RequestBill: No companyCode provided');
        return;
      }

      try {
        const companyDocRef = doc(db, 'companies', companyCode);
        const companyDoc = await getDoc(companyDocRef);
        if (companyDoc.exists()) {
          const companyData = companyDoc.data();
          setCompanyName(companyData.name || 'Unknown Company');
          setCompanyAddress(companyData.address || 'N/A');
          setCompanyPhone(companyData.phone || 'N/A');
          console.log('RequestBill: Company details fetched:', {
            name: companyData.name,
            address: companyData.address,
            phone: companyData.phone
          });
        } else {
          setCompanyName('Unknown Company');
          setCompanyAddress('N/A');
          setCompanyPhone('N/A');
          console.log('RequestBill: No company found for companyCode:', companyCode);
        }
      } catch (err) {
        console.error('RequestBill: Error fetching company details:', err);
        setCompanyName('Unknown Company');
        setCompanyAddress('N/A');
        setCompanyPhone('N/A');
      }
    };

    const fetchGstPlans = async () => {
      try {
        const gstQuery = query(collection(db, 'gstPlans'), where('companyCode', '==', companyCode));
        const gstSnapshot = await getDocs(gstQuery);
        const gstList = gstSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setGstPlans(gstList);
        console.log(`RequestBill: Fetched ${gstList.length} GST plans for companyCode: ${companyCode}`);
      } catch (error) {
        console.error('RequestBill: Error fetching GST plans:', error);
        setSnackbar({ open: true, message: 'Failed to load GST plans.', severity: 'error' });
      }
    };

    const fetchOrderItems = async () => {
      if (!orderId || !companyCode || !tableId || !effectiveUnitCode) {
        console.log('RequestBill: Missing parameters:', { orderId, companyCode, tableId, unitCode: effectiveUnitCode });
        setSnackbar({ open: true, message: 'Missing order details. Please place an order first.', severity: 'warning' });
        return;
      }

      /*try {
        const ordersQuery = query(
          collection(db, 'orders'),
          where('companyCode', '==', companyCode),
          where('unitCode', '==', effectiveUnitCode),
          where('tableId', '==', tableId),
          where('cartId', '==', cartId),          // ✅ ADD THIS
  where('serviceArea', '==', serviceArea) // ✅ ADD THIS
        );
        const querySnapshot = await getDocs(ordersQuery);
        let matchingOrder = null;
        querySnapshot.forEach((doc) => {
          if (doc.id === orderId) {
            matchingOrder = { id: doc.id, ...doc.data() };
          }
        });
       

        if (matchingOrder) {
          const orderData = matchingOrder;
          const items = orderData.items || [];

          const consolidatedItems = await Promise.all(
            items.reduce((acc, item) => {
              const existing = acc.find(i => i.id === item.id);
              if (existing) {
                existing.quantity += item.quantity;
                return acc;
              } else {
                return [...acc, {
                  id: item.id,
                  name: item.name,
                  quantity: item.quantity,
                  price: item.price,
                }];
              }
            }, []).map(async (item) => {
              try {
                const itemQuery = query(
                  collection(db, 'companymenu'),
                  where('companyCode', '==', companyCode),
                  where('unitCode', '==', effectiveUnitCode),
                  where('name', '==', item.name)
                );
                const itemSnapshot = await getDocs(itemQuery);
                let menuItem = null;
                itemSnapshot.forEach(doc => {
                  menuItem = { id: doc.id, ...doc.data() };
                });

                let basePrice = item.price;
                let cgstAmount = 0;
                let sgstAmount = 0;
                let totalPrice = item.price * item.quantity;
                let gstPercentage = 5; // Default GST

                if (menuItem && menuItem.gstPlan && menuItem.gstPercentage != null && menuItem.cgstAmount != null && menuItem.sgstAmount != null) {
                  const gstPlan = gstPlans.find(plan => plan.gstName === menuItem.gstPlan);
                  if (gstPlan && menuItem.basePrice != null) {
                    gstPercentage = menuItem.gstPercentage;
                    basePrice = menuItem.basePrice;
                    if (gstPlan.inclusive) {
                      const totalGstAmount = item.price - basePrice;
                      cgstAmount = totalGstAmount / 2;
                      sgstAmount = totalGstAmount / 2;
                      totalPrice = item.price * item.quantity; // price is inclusive
                    } else {
                      cgstAmount = menuItem.cgstAmount;
                      sgstAmount = menuItem.sgstAmount;
                      totalPrice = (basePrice + cgstAmount + sgstAmount) * item.quantity;
                    }
                  } else {
                    // Fallback to default 5% GST if gstPlan is missing or invalid
                    basePrice = item.price;
                    const totalGstAmount = basePrice * 0.05;
                    cgstAmount = totalGstAmount / 2;
                    sgstAmount = totalGstAmount / 2;
                    totalPrice = (basePrice + totalGstAmount) * item.quantity;
                    gstPercentage = 5;
                  }
                } else {
                  // Apply default 5% GST if no GST fields
                  basePrice = item.price;
                  const totalGstAmount = basePrice * 0.05;
                  cgstAmount = totalGstAmount / 2;
                  sgstAmount = totalGstAmount / 2;
                  totalPrice = (basePrice + totalGstAmount) * item.quantity;
                  gstPercentage = 5;
                }

                return {
                  ...item,
                  basePrice: parseFloat(basePrice.toFixed(2)),
                  cgstAmount: parseFloat(cgstAmount.toFixed(2)),
                  sgstAmount: parseFloat(sgstAmount.toFixed(2)),
                  totalPrice: parseFloat(totalPrice.toFixed(2)),
                  gstPercentage
                };
              } catch (error) {
                console.error(`RequestBill: Error fetching menu item ${item.name}:`, error);
                return {
                  ...item,
                  basePrice: parseFloat(item.price.toFixed(2)),
                  cgstAmount: parseFloat((item.price * 0.025).toFixed(2)), // Default 2.5% CGST
                  sgstAmount: parseFloat((item.price * 0.025).toFixed(2)), // Default 2.5% SGST
                  totalPrice: parseFloat((item.price * 1.05 * item.quantity).toFixed(2)),
                  gstPercentage: 5
                };
              }
            })
          );

          const baseSubtotalCalc = consolidatedItems.reduce((sum, item) => sum + (item.basePrice * item.quantity), 0);
          const totalCGSTCalc = consolidatedItems.reduce((sum, item) => sum + (item.cgstAmount * item.quantity), 0);
          const totalSGSTCalc = consolidatedItems.reduce((sum, item) => sum + (item.sgstAmount * item.quantity), 0);
          const grandTotalCalc = consolidatedItems.reduce((sum, item) => sum + item.totalPrice, 0);

          setCart(consolidatedItems);
          setBaseSubtotal(parseFloat(baseSubtotalCalc.toFixed(2)));
          setTotalCGST(parseFloat(totalCGSTCalc.toFixed(2)));
          setTotalSGST(parseFloat(totalSGSTCalc.toFixed(2)));
          setGrandTotal(parseFloat(grandTotalCalc.toFixed(2)));
          console.log('RequestBill: Fetched and consolidated items for orderId:', orderId, consolidatedItems);
        } else {
          setCart([]);
          setBaseSubtotal(0);
          setTotalCGST(0);
          setTotalSGST(0);
          setGrandTotal(0);
          setSnackbar({ open: true, message: 'No matching order found.', severity: 'warning' });
          console.log('RequestBill: No matching order found for orderId:', orderId);
        }
      }*/ 
     try {
  const ordersQuery = query(
    collection(db, 'orders'),
    where('companyCode', '==', companyCode),
    where('unitCode', '==', effectiveUnitCode),
    where('tableId', '==', tableId),
    where('cartId', '==', cartId), 
   
  );

  const querySnapshot = await getDocs(ordersQuery);

  if (querySnapshot.empty) {
    setCart([]);
    setBaseSubtotal(0);
    setTotalCGST(0);
    setTotalSGST(0);
    setGrandTotal(0);
    setSnackbar({ open: true, message: 'No matching order found.', severity: 'warning' });
    return;
  }

  // ✅ Get first matching order
  const docData = querySnapshot.docs[0];
  const orderData = { id: docData.id, ...docData.data() };

  const items = orderData.items || [];

  const consolidatedItems = await Promise.all(
    items.reduce((acc, item) => {
      const existing = acc.find(i => i.id === item.id);
      if (existing) {
        existing.quantity += item.quantity;
        return acc;
      } else {
        return [...acc, {
          id: item.id,
          name: item.name,
          quantity: item.quantity,
          price: item.price,
        }];
      }
    }, []).map(async (item) => {
      try {
        const itemQuery = query(
          collection(db, 'companymenu'),
          where('companyCode', '==', companyCode),
          where('unitCode', '==', effectiveUnitCode),
          where('name', '==', item.name)
        );

        const itemSnapshot = await getDocs(itemQuery);
        let menuItem = null;

        itemSnapshot.forEach(doc => {
          menuItem = { id: doc.id, ...doc.data() };
        });

        let basePrice = item.price;
        let cgstAmount = 0;
        let sgstAmount = 0;
        let totalPrice = item.price * item.quantity;
        let gstPercentage = 5;

        if (
          menuItem &&
          menuItem.gstPlan &&
          menuItem.gstPercentage != null &&
          menuItem.cgstAmount != null &&
          menuItem.sgstAmount != null
        ) {
          const gstPlan = gstPlans.find(plan => plan.gstName === menuItem.gstPlan);

          if (gstPlan && menuItem.basePrice != null) {
            gstPercentage = menuItem.gstPercentage;
            basePrice = menuItem.basePrice;

            if (gstPlan.inclusive) {
              const totalGstAmount = item.price - basePrice;
              cgstAmount = totalGstAmount / 2;
              sgstAmount = totalGstAmount / 2;
              totalPrice = item.price * item.quantity;
            } else {
              cgstAmount = menuItem.cgstAmount;
              sgstAmount = menuItem.sgstAmount;
              totalPrice = (basePrice + cgstAmount + sgstAmount) * item.quantity;
            }
          }
        } else {
          const totalGstAmount = basePrice * 0.05;
          cgstAmount = totalGstAmount / 2;
          sgstAmount = totalGstAmount / 2;
          totalPrice = (basePrice + totalGstAmount) * item.quantity;
        }

        return {
          ...item,
          basePrice: parseFloat(basePrice.toFixed(2)),
          cgstAmount: parseFloat(cgstAmount.toFixed(2)),
          sgstAmount: parseFloat(sgstAmount.toFixed(2)),
          totalPrice: parseFloat(totalPrice.toFixed(2)),
          gstPercentage
        };

      } catch (error) {
        console.error(`Error fetching menu item ${item.name}:`, error);
        return {
          ...item,
          basePrice: item.price,
          cgstAmount: item.price * 0.025,
          sgstAmount: item.price * 0.025,
          totalPrice: item.price * 1.05 * item.quantity,
          gstPercentage: 5
        };
      }
    })
  );

  const baseSubtotalCalc = consolidatedItems.reduce((sum, item) => sum + (item.basePrice * item.quantity), 0);
  const totalCGSTCalc = consolidatedItems.reduce((sum, item) => sum + (item.cgstAmount * item.quantity), 0);
  const totalSGSTCalc = consolidatedItems.reduce((sum, item) => sum + (item.sgstAmount * item.quantity), 0);
  const grandTotalCalc = consolidatedItems.reduce((sum, item) => sum + item.totalPrice, 0);

  setCart(consolidatedItems);
  setBaseSubtotal(baseSubtotalCalc);
  setTotalCGST(totalCGSTCalc);
  setTotalSGST(totalSGSTCalc);
  setGrandTotal(grandTotalCalc);

}catch (err) {
        console.error('RequestBill: Error fetching order:', err);
        setCart([]);
        setBaseSubtotal(0);
        setTotalCGST(0);
        setTotalSGST(0);
        setGrandTotal(0);
        setSnackbar({ open: true, message: 'Failed to load order details.', severity: 'error' });
      }
    };

    fetchCompanyDetails();
    if (companyCode) fetchGstPlans();
    fetchOrderItems();
  }, [orderId, tableId, companyCode, effectiveUnitCode]);

  const isCartValid = Array.isArray(cart) && cart.length > 0;

  console.log('RequestBill: orderId:', orderId);
  console.log('RequestBill: tableId:', tableId);
  console.log('RequestBill: companyCode:', companyCode);
  console.log('RequestBill: unitCode:', effectiveUnitCode);
  console.log('RequestBill: cart:', cart);
  console.log('RequestBill: baseSubtotal:', baseSubtotal);
  console.log('RequestBill: totalCGST:', totalCGST);
  console.log('RequestBill: totalSGST:', totalSGST);
  console.log('RequestBill: grandTotal:', grandTotal);

  const generatePDF = () => {
    const doc = new jsPDF({ format: 'a4' });
    
    doc.setTextColor(0);
    doc.setDrawColor(0);

    doc.setFont('helvetica', 'bold');
    doc.setFontSize(24);
    doc.text(companyName || 'Scan & Dine', 105, 20, { align: 'center' });
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);
    doc.text(companyAddress || '123 Food Street, City, India', 105, 28, { align: 'center' });
    doc.text(`Phone: ${companyPhone || '+1234567890'}`, 105, 34, { align: 'center' });

    doc.setLineWidth(0.5);
    doc.line(20, 45, 190, 45);

    doc.setFontSize(12);
    doc.text(`Bill No: ${orderId || 'N/A'}`, 105, 55, { align: 'center' });
    doc.text(`Table No: ${tableId || 'N/A'}`, 105, 61, { align: 'center' });
    doc.text(`Unit: ${effectiveUnitCode || 'N/A'}`, 105, 67, { align: 'center' });
    doc.setFontSize(10);
    doc.text(`Date: ${new Date().toLocaleString('en-IN', { dateStyle: 'medium', timeStyle: 'short' })}`, 105, 73, { align: 'center' });

    autoTable(doc, {
      startY: 81,
      head: [['Item', 'Qty', 'Base Price', 'CGST', 'SGST', 'Total']],
      body: cart.map(item => [
        item.name,
        item.quantity,
        `₹${item.basePrice.toFixed(2)}`,
        `₹${item.cgstAmount.toFixed(2)} (${(item.gstPercentage / 2).toFixed(2)}%)`,
        `₹${item.sgstAmount.toFixed(2)} (${(item.gstPercentage / 2).toFixed(2)}%)`,
        `₹${item.totalPrice.toFixed(2)}`
      ]),
      theme: 'plain',
      headStyles: {
        fontStyle: 'bold',
        fontSize: 10,
        textColor: 0
      },
      bodyStyles: { fontSize: 10, textColor: 0 },
      columnStyles: {
        0: { cellWidth: 60 },
        1: { cellWidth: 20, halign: 'left' },
        2: { cellWidth: 30, halign: 'left' },
        3: { cellWidth: 30, halign: 'left' },
        4: { cellWidth: 30, halign: 'left' },
        5: { cellWidth: 40, halign: 'left' }
      },
      margin: { left: 20, right: 20 },
      styles: { cellPadding: 2 }
    });

    const finalY = doc.lastAutoTable.finalY + 10;
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);
    doc.text(`Base Subtotal: ₹${baseSubtotal.toFixed(2)}`, 180, finalY, { align: 'right' });
    doc.text(`Total CGST: ₹${totalCGST.toFixed(2)}`, 180, finalY + 8, { align: 'right' });
    doc.text(`Total SGST: ₹${totalSGST.toFixed(2)}`, 180, finalY + 16, { align: 'right' });
    doc.setLineWidth(0.5);
    doc.line(150, finalY + 22, 180, finalY + 22);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(14);
    doc.text(`Grand Total: ₹${grandTotal.toFixed(2)}`, 180, finalY + 30, { align: 'right' });

    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);
    doc.text('Thank you for dining with us!', 105, finalY + 40, { align: 'center' });
    doc.text('Visit again!', 105, finalY + 46, { align: 'center' });

    return doc;
  };

  const handleDownloadPDF = () => {
    const doc = generatePDF();
    doc.save(`bill_${orderId || 'unknown'}.pdf`);
    console.log('RequestBill: PDF downloaded for orderId:', orderId);
  };

  const handleClose = () => {
    setSnackbar({ open: false, message: '', severity: 'success' });
  };

  const handleBackToMenu = () => {
    console.log('RequestBill: Navigating to menu:', { companyCode, unitCode: effectiveUnitCode, tableId });
    navigate(`/customer/menu?code=${companyCode}&unit=${effectiveUnitCode}&id=${tableId}`, { state: { tableId, companyCode, unitCode: effectiveUnitCode } });
  };

  const handleMakePayment = () => {
    console.log('RequestBill: Navigating to payments:', { tableId, orderId, cart, baseSubtotal, totalCGST, totalSGST, grandTotal, companyCode, unitCode: effectiveUnitCode });
    navigate(`/customer/payments?code=${companyCode}&unit=${effectiveUnitCode}&id=${tableId}`, {
      state: { tableId, orderId, cart, baseSubtotal, totalCGST, totalSGST, grandTotal, companyCode, unitCode: effectiveUnitCode }
    });
  };

  return (
    <Box sx={{ position: 'relative' }}>
      <Alerts snackbar={snackbar} handleClose={handleClose} darkMode={false} />
      <Container
        maxWidth={isMobile ? 'xs' : 'lg'}
        sx={{
          py: 3,
          px: isMobile ? 1 : 2,
        }}
      >
        <Paper elevation={3} sx={{ p: isMobile ? 2 : 3, width: '100%', maxWidth: isMobile ? '100%' : 800, mx: 'auto', borderRadius: 2 }}>
          <Typography variant={isMobile ? 'h5' : 'h4'} gutterBottom sx={{ textAlign: 'center', mb: 2 }}>
            {companyName || 'Scan & Dine'}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', mb: 1 }}>
            {companyAddress || '123 Food Street, City, India'}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', mb: 2 }}>
            Phone: {companyPhone || '+1234567890'}
          </Typography>
          <Divider sx={{ mb: 2 }} />

          {!orderId || !tableId || !companyCode || !effectiveUnitCode || !isCartValid ? (
            <Box sx={{ textAlign: 'center', py: 3 }}>
              <Typography variant="h6" color="text.secondary">
                Please place the order first, then request a bill.
              </Typography>
              <Button
                variant="contained"
                color="primary"
                onClick={handleBackToMenu}
                sx={{ mt: 2 }}
              >
                Back to Menu
              </Button>
            </Box>
          ) : (
            <>
              <Box sx={{ mb: 2 }}>
                <Typography variant="body1" sx={{ textAlign: 'center' }}>
                  Bill No: {orderId || 'N/A'}
                </Typography>
                <Typography variant="body1" sx={{ textAlign: 'center' }}>
                  Table No: {tableId}
                </Typography>
                <Typography variant="body1" sx={{ textAlign: 'center' }}>
                  Unit: {effectiveUnitCode || 'N/A'}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center' }}>
                  Date: {new Date().toLocaleString('en-IN', { dateStyle: 'medium', timeStyle: 'short' })}
                </Typography>
              </Box>

              <TableContainer>
                <Table size={isMobile ? 'small' : 'medium'}>
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 'bold', fontSize: isMobile ? '0.75rem' : '0.875rem' }}>Item</TableCell>
                      <TableCell align="right" sx={{ fontWeight: 'bold', fontSize: isMobile ? '0.75rem' : '0.875rem' }}>Qty</TableCell>
                      <TableCell align="right" sx={{ fontWeight: 'bold', fontSize: isMobile ? '0.75rem' : '0.875rem' }}>Base Price</TableCell>
                      <TableCell align="right" sx={{ fontWeight: 'bold', fontSize: isMobile ? '0.75rem' : '0.875rem' }}>CGST</TableCell>
                      <TableCell align="right" sx={{ fontWeight: 'bold', fontSize: isMobile ? '0.75rem' : '0.875rem' }}>SGST</TableCell>
                      <TableCell align="right" sx={{ fontWeight: 'bold', fontSize: isMobile ? '0.75rem' : '0.875rem' }}>Total</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {cart.map((item) => (
                      <TableRow key={item.id}>
                        <TableCell sx={{ fontSize: isMobile ? '0.75rem' : '0.875rem' }}>{item.name}</TableCell>
                        <TableCell align="right" sx={{ fontSize: isMobile ? '0.75rem' : '0.875rem' }}>{item.quantity}</TableCell>
                        <TableCell align="right" sx={{ fontSize: isMobile ? '0.75rem' : '0.875rem' }}>₹{item.basePrice.toFixed(2)}</TableCell>
                        <TableCell align="right" sx={{ fontSize: isMobile ? '0.75rem' : '0.875rem' }}>₹{item.cgstAmount.toFixed(2)} ({(item.gstPercentage / 2).toFixed(2)}%)</TableCell>
                        <TableCell align="right" sx={{ fontSize: isMobile ? '0.75rem' : '0.875rem' }}>₹{item.sgstAmount.toFixed(2)} ({(item.gstPercentage / 2).toFixed(2)}%)</TableCell>
                        <TableCell align="right" sx={{ fontSize: isMobile ? '0.75rem' : '0.875rem' }}>₹{item.totalPrice.toFixed(2)}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>

              <Box sx={{ mt: 2, textAlign: 'right' }}>
                <Typography variant="body2" sx={{ fontSize: isMobile ? '0.75rem' : '0.875rem' }}>Base Subtotal: ₹{baseSubtotal.toFixed(2)}</Typography>
                <Typography variant="body2" sx={{ fontSize: isMobile ? '0.75rem' : '0.875rem' }}>Total CGST: ₹{totalCGST.toFixed(2)}</Typography>
                <Typography variant="body2" sx={{ fontSize: isMobile ? '0.75rem' : '0.875rem' }}>Total SGST: ₹{totalSGST.toFixed(2)}</Typography>
                <Divider sx={{ my: 1 }} />
                <Typography variant="h6" sx={{ fontSize: isMobile ? '1rem' : '1.25rem' }}>Grand Total: ₹{grandTotal.toFixed(2)}</Typography>
              </Box>

              <Box sx={{ textAlign: 'center', mt: 2 }}>
                <Typography variant="body2" color="text.secondary" sx={{ fontSize: isMobile ? '0.75rem' : '0.875rem' }}>
                  Thank you for dining with us!
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ fontSize: isMobile ? '0.75rem' : '0.875rem' }}>
                  Visit again!
                </Typography>
              </Box>

              <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 3, flexWrap: isMobile ? 'wrap' : 'nowrap' }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleDownloadPDF}
                  size={isMobile ? 'small' : 'medium'}
                >
                  Download PDF
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleMakePayment}
                  size={isMobile ? 'small' : 'medium'}
                >
                  Make Payment
                </Button>
              </Box>
            </>
          )}
        </Paper>
      </Container>
    </Box>
  );
}